<template>
	<page>
		<module drag="disabled">
			<module-col size="190">
				<ul class="menu">
					<li v-for="(item, i) in customFieldMenu" :key="i" class="flex-between-center" :class="{'z-crt': item.menu_unique_key == `m_custom_${type}`}" @click="navigateTo(item.menu_unique_key.replace('m_custom_', '/custom/field/'))">
						<p>{{item.menu_name}}</p>
						<i class="tf" v-if="item.menu_unique_key == `m_custom_${type}`">&#xeb08;</i>
					</li>
				</ul>
			</module-col>

			<module-col enable-flex>
				<m-operate>
					<c-button color="main" prepend-icon="tf-add" @click="$refs.fieldEdit.open()">添加新字段</c-button>
				</m-operate>

				<c-table ref="list" height="grow" :paging="false">
					<c-table-column
						type="drag"
						@handle="dragHandle"
					></c-table-column>
					
					<c-table-column
						label="字段名称"
						name="field_title"
						width="250"
					></c-table-column>

					<c-table-column
						label="字段类型"
						width="100"
					>
						<template #default="{data}">
							<c-state dict="fieldType" :value="data.config_json.type"></c-state>
						</template>
					</c-table-column>
					
					<c-table-column
						label="字段属性"
						width="200"
					>
						<template #default="{data}">
							{{parseAttr(data.config_json.attr)}}
						</template>
					</c-table-column>

					<c-table-column
						label="创建人"
						name="create_user_realname"
						width="100"
					></c-table-column>
					
					<c-table-column
						label="创建时间"
						name="create_date"
						width="120"
					></c-table-column>
					
					<c-table-column
						label="编辑时间"
						name="edit_date"
						width="120"
					></c-table-column>

					<c-table-column
						type="button"
						label="操作"
						width="150"
					>
						<template #default="{data}">
							<c-table-button icon="tf-edit" @click="$refs.fieldEdit.open(data)">编辑</c-table-button>
							<c-table-button icon="tf-edit" @click="$refs.fieldEdit.open(data, true)">复制</c-table-button>
							<c-table-button icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</module-col>
		</module>

		<field-edit ref="fieldEdit" :type="workType" :workTypeDict="workTypeDict" @resolve="$refs.list.update()"></field-edit>
	</page>
</template>

<script>
	import fieldEdit from './field_edit.vue'
	import {mapGetters} from 'vuex'

	export default {
		components: {
			fieldEdit
		},
		
		props: {
			type: String
		},

		data() {
			return {
				workTypeDict: {
					product: 7,
					process: 9,
					work: 3,
					customer: 11,
					supplier: 12,
					output: 14,
					order: 1,
					plan: 2,
					storage: 20,
					storagedetail: 21,
					systemuser: 27,
					orderdeliver: 32,
					deliverdetail: 33,
					assemble: 34,
					outsourcingprogress: 35,	//委外动态
					outsourcingsettle: 36,		//结算单
					purchase: 39,				//采购单
					purchasedetail: 40,			//采购单详情
					orderdetail: 41,			//销售订单详情
					qualityoutput: 42,			//报工质检
					quality: 44,           		//质检单
					plandetail: 48,				//生产计划详情
					stockbatch: 49,				//批次库存
					collabtask: 51,				//协同任务
					collabtaskrecord: 52		//协同任务处理记录
				}
			}
		},

		computed: {
			...mapGetters(['customFieldMenu']),

			workType() {
				return this.workTypeDict[this.type];
			}
		},

		watch: {
			workType() {
				this.update();
			}
		},

		mounted() {
			this.update();
		},

		methods: {
			update() {
				this.$refs.list.load({
					url: '/sys_field/list',
					data: {
						work_type_id: this.workType
					}
				})
			},

			deleteHandle(data) {
				this.$confirm({
					title: '确认删除字段？',
					message: '删除后将同时删除历史数据，且不可恢复',
					resolve: () => {
						this.request({
							url: '/sys_field/delete',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功'
								});
								this.$refs.list.update();
							}
						})
					}
				});
			},

			dragHandle() {
				this.request({
					url: '/sys_field/sort',
					data: {
						work_type_id: this.workType,
						field_list: this.$refs.list.getData().map((item, index) => {
							return {
								id: item.id,
								sortid: index + 1
							}
						})
					},
					success: () => {
						this.$emit('sort', false);
					}
				})
			},

			parseAttr(list) {
				let dict = {
					required: '必填',
					readonly: '只读',
					scan: '扫码输入',
					suggest: '支持预设值',
					decimal: '支持小数',
					multiple: '多选',
					add: '允许添加选项'
				};
				return ['required', 'readonly', 'scan', 'suggest', 'decimal', 'multiple', 'add'].filter(item => list.includes(item)).map(item => dict[item]).join('、');
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.menu {
		padding: 12px 0;

		li {
			position: relative;
			height: 40px;
			padding: 0 12px 0 20px;
			font-size: 13px;
			color: #444;
			cursor: pointer;

			&:hover {
				background: #F7F7F7;
			}

			&.z-crt {
				font-weight: bold;
				color: var(--color-main);
				background: #F7F7F7;
				
				&:before {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					bottom: 0;
					width: 3px;
					background: var(--color-main);
				}
			}
		}
	}
</style>